import { camelCase, snakeCase } from 'lodash';
import { isDateString } from './date';


export const isObjectEmpty = (value: any) => {
  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }

  return false;
};

export const cleanObject = (obj: Record<any, any>): Record<string, any> => {
  return Object.keys(obj).reduce<Record<string, any>>((newObj, key) => {
    const value = obj[key];

    if (value && typeof value === 'object' && !Array.isArray(value)) {
      const cleanedNested = cleanObject(value);
      if (Object.keys(cleanedNested).length > 0) {
        newObj[key] = cleanedNested;
      }
    } else if (![null, undefined, ''].includes(value)) {
      newObj[key] = value;
    }

    return newObj;
  }, {});
};

export const snakizeObject = <T>(obj: Record<string, any>): T => {
  // @ts-ignore
  return Object.keys(obj).reduce(
    (result, key) => ({
      ...result,
      [snakeCase(key)]: processObjectKeyValue(obj[key], snakizeObject),
    }),
    {},
  );
};

const processObjectKeyValue = (value: any, func: (value: any) => any): any => {

  if (!value) {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map((v) => processObjectKeyValue(v, func));
  }

  if (typeof value === 'object') {
    return func(value);
  }

  if (isDateString(value)) {
    return new Date(value);
  }

  return value;
};

export const camelizeObject = <T>(obj: Record<string, any>): T => {
  // @ts-ignore
  return Object.keys(obj).reduce(
    (result, key) => ({
      ...result,
      [camelCase(key)]: processObjectKeyValue(obj[key], camelizeObject),
    }),
    {},
  );
};
